import { getFrontendConfigLoader } from '@doxyme/config';
import { type RealtimeIdentity, RealtimeRole } from '@doxyme/realtime';
import { getLogger } from '../../libs/logger';

const logger = getLogger('RealtimeDebugger');

const isDebuggingEnabled =
  getFrontendConfigLoader().get('IS_REALTIME_DEBUGGER_ENABLED') === 'true';

export class RealtimeDebugger {
  private readonly patientsWhoLeft = new Set<string>();

  patientJoin(patient: RealtimeIdentity): void {
    const patientLeft = this.patientsWhoLeft.has(patient.id);

    if (patientLeft && isDebuggingEnabled) {
      logger.error('[RealtimeDebugger] Ghost patient detected', { patient });
    }
  }

  patientLeft(patient: RealtimeIdentity): void {
    if (patient.role === RealtimeRole.Patient) {
      this.patientsWhoLeft.add(patient.id);
    }
  }
}
